import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth'; // Import signInWithPopup
import { signInWithPopup } from 'firebase/auth';

// Function to get Firebase configuration based on the environment
const getFirebaseConfig = () => {
    if (typeof window !== 'undefined' && window.FIREBASE_CONFIG) {
        // Use Firebase config from Firebase Hosting (when running in the browser)
        return window.FIREBASE_CONFIG;
    } else {
        // Use environment variables for local development or other environments
        return {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
        };
    }
};
console.log(getFirebaseConfig())


const firebaseConfig = getFirebaseConfig();

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup }; // Export signInWithPopup
